// extracted by mini-css-extract-plugin
export default {"container":"Calc_container__a4Pee","content":"Calc_content__6gbHN"};